storeRedirection()
variantHover();
accordionCustom();
dropDownHover();

function storeRedirection(){
  fetch('https://api.ipgeolocation.io/ipgeo?apiKey=3cf6452e8c844bfe8ef4b265987883bc')
    .then(function(response) {
        return response.json();
    })
    .then(function(data) {
        var countryCode = data.country_code2; // Use the correct property for country code
        
        if (countryCode === 'SA') {
            window.location.href = 'https://sa.avancus.com';
        } else if (countryCode === 'AE' || countryCode === 'BH' || countryCode === 'QA' || countryCode === 'OM') {
            window.location.href = 'https://ae.avancus.com';
        } else {
            console.log('countryCode', countryCode)
        }
    })
    .catch(function(error) {
        console.log(error);
    });
}

function variantHover() {
  const variantImages = document.querySelectorAll(".variant_images ul li");
  variantImages.forEach((variant) => {
    const updateMainImage = () => {
      // Get the large image source from the data attribute
      const largeImageSrc = variant.dataset.large;
      const variantContainer = variant.closest(".variant_images");
      // Inline swatches live inside the card; legacy swatches are immediately before it.
      const card =
        variantContainer?.closest(".card") ||
        variantContainer?.nextElementSibling?.querySelector(".card");
      const mainImage = card?.querySelector(".card__media .media > img:first-child");
      // Check if the main image exists before updating
      if (mainImage) {
        mainImage.src = largeImageSrc;
        mainImage.srcset = ""; // Clear srcset if needed
      } else {
        console.warn("Main image not found");
      }
    };

    variant.addEventListener("mouseenter", updateMainImage);
    variant.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      updateMainImage();
    });
  });
}

function accordionCustom() {
  const items = document.querySelectorAll(".custom-accordion-item");
  items.forEach((item) => {
    item
      .querySelector(".custom-accordion-header")
      .addEventListener("click", () => {
        items.forEach((i) => {
          if (i !== item) {
            i.classList.remove("active");
            i.querySelector(".custom-accordion-toggle").textContent = "+";
          }
        });

        item.classList.toggle("active");
        const toggle = item.querySelector(".custom-accordion-toggle");
        toggle.textContent = item.classList.contains("active") ? "−" : "+";
      });
  });
}

function sizeTabs(productId) {
  console.log(productId);

  if(!localStorage.lastTabClick && !localStorage.lastVariantClick){
    localStorage.setItem('lastTabClick', 'men')
    localStorage.setItem('lastVariantClick', '36')
  }
  
  let sizetabs = document.querySelectorAll("#" + productId + " .size-tabs li");
  let variantRadios = document.querySelectorAll(
    "#" + productId + " variant-selects label"
  );
  
  sizetabs.forEach((item) => {
    item.onclick = (e) => {
      let tabName = e.target.dataset.id;
      let active = document.querySelector("#" + productId + " .active");
      if (active !== null) {
        active.classList.remove("active");
      }
      e.target.classList.add("active");
      localStorage.setItem('lastTabClick', tabName)
      
      variantRadios.forEach((label) => {
        let getSize =
          label.dataset[tabName] || label.previousElementSibling?.value;
        if (getSize == "x" || getSize == "X") {
          label.style.display = "none";
        } else {
          label.style.display = "";
        }
        label.textContent = getSize;
      });
    };
  });

  if(localStorage.lastTabClick == "men"){
    document.querySelectorAll('.size-tabs li')[0].click()
  }else if(localStorage.lastTabClick == "women"){
    document.querySelectorAll('.size-tabs li')[1].click()
  }else if(localStorage.lastTabClick == "uk"){
    document.querySelectorAll('.size-tabs li')[2].click()
  }else if(localStorage.lastTabClick == "eu"){
    document.querySelectorAll('.size-tabs li')[3].click()
  }
  document.querySelector(`.product-form__input input[value="${localStorage.lastVariantClick}"]`).click()
  
}

function sizeGuidTrigger(){
  let id = document.querySelector('.size-guid-link').id
  let target = "";
  console.log(id)
  if(id == "t"){
    target = document.getElementById('popup_tees')
  }else{
    target = document.querySelector('.product-popup-modal__button')
  }
  let btn = document.querySelector('.size-guid-link');
  btn.onclick = (e) => {
    target.click();
  }
}

function tableSwitch(){
  console.log('Size switch')
  const toggle = document.getElementById("unitToggle");
  const cells = document.querySelectorAll("#sizeTable td[data-cm]");

  toggle.addEventListener("change", () => {
    cells.forEach(cell => {
      cell.textContent = toggle.checked
        ? cell.dataset.in
        : cell.dataset.cm;
    });
  });
}

function pdpPopup(){
  const items = document.querySelectorAll(".product_details_popups ul li");
  const close = document.querySelectorAll('.product_info_popup .svg-wrapper')
  items.forEach((item) => {
    item.addEventListener("click", (event) => {
      const popupId = item.dataset.popup;
      const openState = document.getElementById(popupId)
      openState.setAttribute('open','')
      document.body.classList.add('overflow-hidden')
    });
  });

  if(close.length > 0){
    close.forEach((item) => {
      item.addEventListener("click", (event) => {
        item.parentElement.removeAttribute('open')
        document.body.classList.remove('overflow-hidden')
      });
    })
  }
  
}

document.addEventListener('DOMContentLoaded', function () {
  fetch(routes.cart_url+'.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length > 0) {
        loadMiniCartRecommendations(cart.items[0].product_id);
      }else{
          console.log('No products in Cart')
      }
    });
});

function loadMiniCartRecommendations(productId) {
  fetch(window.Shopify.routes.root + `recommendations/products?section_id=product-recommendations-cart&limit=4&product_id=${productId}`)
    .then(response => response.text())
    .then(text => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations) {
        const container = document.getElementById('MiniCartRecommendations');
        if (container) container.innerHTML = recommendations.innerHTML;
      }
    });
}


function dropDownHover() {
  let sticky = document.querySelector('.shopify-section-header-sticky')
  //sticky.classList.contains('scrolled-past-header')
  document.querySelectorAll('.mega-menu').forEach(menu => {
    let timeout;
    
    menu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      menu.setAttribute('open', '');
      if(!sticky.classList.contains('scrolled-past-header')){
        sticky.classList.add('scrolled-past-header')
      }
    });
  
    menu.addEventListener('mouseleave', () => {
      
      timeout = setTimeout(() => {
        menu.removeAttribute('open');
        if(sticky.classList.contains('scrolled-past-header') && scrollY < 50){
          sticky.classList.remove('scrolled-past-header')
        }
      }, 200);
      
    });
    
  });
}

class CustomSwiper extends HTMLElement {
  constructor() {
    super()
    // basic options for all sliders
	const id = this.dataset.section
    let swiper = document.getElementById(this.id);
    let optionsData = swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {};
	let defaults = {
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };
    let options = {...defaults, ...optionsData};
    setTimeout(()=>{
      new Swiper(swiper, options);
    }, 500)
  }
}
customElements.define('custom-swiper', CustomSwiper);


// ====================================== New PDP popup tabs
let currentTab = null;
function closeCurrentTab() {
    if (currentTab === null) return;
    
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');
    const wrapper = document.querySelector('.tab-content-wrapper');
    
    contents[currentTab].classList.remove('active');
    buttons[currentTab].classList.remove('active');
    buttons[currentTab].querySelector('.tab-icon').textContent = '+';
    wrapper.classList.remove('has-active');
    currentTab = null;
}

function closeTab() {
    closeCurrentTab();
}

function switchTab(index) {
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');
    const wrapper = document.querySelector('.tab-content-wrapper');

    // Toggle if same tab clicked
    if (currentTab === index) {
        closeCurrentTab();
        return;
    }

    // Close current tab if open
    if (currentTab !== null) {
        contents[currentTab].classList.remove('active');
        buttons[currentTab].classList.remove('active');
        buttons[currentTab].querySelector('.tab-icon').textContent = '+';
    }

    // Open new tab
    wrapper.classList.add('has-active');
    contents[index].classList.add('active');
    buttons[index].classList.add('active');
    buttons[index].querySelector('.tab-icon').textContent = '−';
    currentTab = index;
}

// ====================================== Socks PDP: Push tabs to viewport bottom
(function() {
  if (!document.querySelector('.tabs-nav .tab-button')) return;
  if (window.innerWidth < 750) return;

  function positionTabsAtBottom() {
    var tabsNav = document.querySelector('.tabs-nav');
    if (!tabsNav) return;

    var stickyCol = document.querySelector('.product__column-sticky');
    if (!stickyCol) return;

    // Reset margin before measuring
    tabsNav.style.marginTop = '';

    // Find last visible sibling before tabs-nav
    var el = tabsNav.previousElementSibling;
    while (el && el.offsetHeight === 0) {
      el = el.previousElementSibling;
    }
    if (!el) return;

    // Content height within the sticky column (scroll-independent)
    var colTop = stickyCol.getBoundingClientRect().top;
    var contentBottom = el.getBoundingClientRect().bottom - colTop;
    var tabsH = tabsNav.offsetHeight;
    // Account for header height so tabs are visible on initial load too
    var header = document.querySelector('.section-header') || document.querySelector('header');
    var headerH = header ? header.offsetHeight : 0;
    var gap = window.innerHeight - contentBottom - tabsH - headerH - 10;

    if (gap > 20) {
      tabsNav.style.marginTop = gap + 'px';
    }
  }

  window.addEventListener('load', positionTabsAtBottom);
  window.addEventListener('resize', positionTabsAtBottom);
})();

// ====================================== Size Guide: Strip inline bgcolor & background styles
(function() {
  function cleanSizeGuideTable() {
    document.querySelectorAll('.product-popup-modal__content-info table').forEach(function(table) {
      // Remove bgcolor from the table itself
      table.removeAttribute('bgcolor');
      table.style.removeProperty('background');
      table.style.removeProperty('background-color');

      // Clean all cells: td, th, tr, thead, tbody
      table.querySelectorAll('td, th, tr, thead, tbody').forEach(function(el) {
        el.removeAttribute('bgcolor');
        el.style.removeProperty('background');
        el.style.removeProperty('background-color');
      });
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', cleanSizeGuideTable);

  // Also run when any popup modal opens (MutationObserver)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        setTimeout(cleanSizeGuideTable, 50);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-popup-modal').forEach(function(modal) {
      observer.observe(modal, { attributes: true });
    });
  });
})();
